<template>
    <div>
        <sweet-modal blocking :title="$t('modal_unShareTask')" ref="unShareTaskModal" v-on:close="closeModal">
            <el-form :model="unShareTask" status-icon ref="unShareTask"  class="unshare-task">
                <!--{{unShareTask.userId}}-->
                <el-form-item>
                    <el-select v-model="unShareTask.userId" :placeholder="$t('modal_selectUsers')" multiple style="width: 100%;">
                        <el-option v-for="item in unShareTask.userList"
                                   :key="item.id"
                                   :label="item.sharedCompanyUser.user.fullName"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="modal__btn">
                  <el-button @click="modalCancel('unShareTaskModal')">{{$t('general_cancel')}}</el-button>
                  <el-button @click="unShareTaskSubmit" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
    </div>
</template>

<script>
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import axios from 'axios'

  export default {
    props:['selectedRow'],
    components:{
      SweetModal,

    },
    data() {
      return {
        unShareTask:{
          userId:[],
          userList: []
        }
      }
    },
    methods:{
      modalCancel(ref) {
        this.$refs[ref].close();
      },
        openUnShareTaskModal(){
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/sharedProjectTasks/listByProjectTask?companyId=${this.$route.query.companyId}&projectId=${this.selectedRow.projectId}&projectTaskId=${this.selectedRow.id}`)
            .then(response => {
              console.log(response)
              this.unShareTask.userList = response.data.list;
              this.$refs.unShareTaskModal.open();
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            })
        },
      unShareTaskSubmit(){
        let loader = this.$loading.show();
        let data = {
          sharedProjectTaskIdList: this.unShareTask.userId
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/sharedProjectTasks/deleteListBySharedCompanyUser?companyId=${this.$route.query.companyId}&projectId=${this.selectedRow.projectId}&projectTaskId=${this.selectedRow.id}`, data)
          .then(response => {
            console.log(response)
            this.$emit('submit', this.selectedRow.projectId, false, this.selectedRow.id)
            this.$refs.unShareTaskModal.close();
            this.notification("Success", "Un-share", "success")
            loader.hide()
          })
          .catch(error => {
            this.$refs.unShareTaskModal.close();
            console.log('An error occurred:', error);
            loader.hide()
          })
      },
      closeModal(){
         this.unShareTask.userId = []
         this.unShareTask.userList = []
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    }
  }
</script>
